import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import type { TFunction } from "react-i18next"
import { Text, Button } from "@oysterhr/ui"
import {
  companyPaymentMethodsAchBankDetailsPath,
  companyPaymentMethodsPath,
} from "@oysterhr/router"
import ConnectPaymentMethodLayout from "../../../layouts/ConnectPaymentMethodLayout"
import { PlaidLinkFlow } from "../../plaid/PlaidLinkFlow"

const directionsForPlaid = (t: TFunction) => [
  t("directionsForPlaid.step1"),
  t("commonSteps.authorizationStep"),
  t("commonSteps.shareLinkWithBankStep"),
]

const directionsForManuallySettingUpAccount = (t: TFunction) => [
  t("directionsForManuallySettingUpAccount.step1"),
  t("directionsForManuallySettingUpAccount.step2"),
  t("directionsForManuallySettingUpAccount.step3"),
  t("commonSteps.authorizationStep"),
  t("commonSteps.shareLinkWithBankStep"),
]

// NOTE: This represents the old connect payment method
const AchLandingPage = () => {
  const { accountAspect: companyId } = useAccountAspect()
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/AchLandingPage")
  const navigate = useNavigate()

  return (
    <ConnectPaymentMethodLayout title={t("title")}>
      <div
        className="relative rounded-lg border-2 border-gray-200 bg-white p-2 text-left md:p-8"
        style={{ width: 600 }}
      >
        <Text size="large" className="font-semibold">
          {t("subtitle")}
        </Text>

        <Text className="mt-8 font-semibold">{t("options.optionA")}</Text>
        <ol className="mt-6 list-decimal rounded-lg border-2 border-gray-100 p-4">
          {directionsForPlaid(t).map(direction => (
            <li className="ml-5" key={direction}>
              <Text as="span">{direction}</Text>
            </li>
          ))}
        </ol>
        <div className="mt-8">
          <PlaidLinkFlow
            companyId={companyId}
            onSubmit={() => navigate(companyPaymentMethodsPath(companyId))}
          />
        </div>
        <Text className="mt-8 font-semibold">{t("options.optionB")}</Text>
        <ol className="mt-6 list-decimal rounded-lg border-2 border-gray-100 p-4">
          {directionsForManuallySettingUpAccount(t).map(direction => (
            <li className="ml-5" key={direction}>
              <Text as="span">{direction}</Text>
            </li>
          ))}
        </ol>
        <Button
          data-analytics-name="company_payment_methods-ach-manually-connect-account"
          variation="secondary"
          className="mt-8"
          onClick={() => navigate(companyPaymentMethodsAchBankDetailsPath(companyId))}
        >
          {t("actions.connectManually")}
        </Button>
        <div className="mt-11">
          <Text size="small" className="font-semibold">
            {t("note")}
          </Text>
          <Text size="small">{t("noteDescription")}</Text>
        </div>
      </div>
    </ConnectPaymentMethodLayout>
  )
}

export default AchLandingPage
